module.exports = __webpack_public_path__ + "img/bottle-right.97ae07a0.png";